import { mdiCheck, mdiClose, mdiPencil, mdiDelete, mdiPlus } from "@mdi/js";
import Icon from "@mdi/react";
import { FunctionComponent, useEffect, useRef, useState } from "react";
import {
  useToast,
  ToastType,
} from "../../../../context_providers/toast/toast_ctx";
import { defaultInwardItem, InwardItemModel } from "../../models/npd_model";
import { ItemModelV2 } from "../../models/item_model";
import POItemSearchFieldV2 from "../../../purchase_order/purchase_order_create/components/po-item-search-widget";
import WarehouseSearchField from "../../warehouse/warehouse_search_field";
import { generate_id } from "../../journals/destination_stock_voucher/components/item_row_status";
import { fetchGet } from "../../../../service/api_client";

interface BOMItemComponentProps {
  data?: InwardItemModel;
  onSubmit: (data: InwardItemModel) => void;
  edit: boolean;
  disabled: boolean;
  onDelete?: (i: InwardItemModel) => void;
  existingItems?: InwardItemModel[];
  product: ItemModelV2;
}

const InwardProductComponent: FunctionComponent<BOMItemComponentProps> = (
  props
) => {
  const [data, setData] = useState<InwardItemModel>({
    ...defaultInwardItem,
    id: generate_id(),
  });

  const uniqueIdRef = useRef<HTMLInputElement>(null);

  const { showToast } = useToast();
  const { edit, onSubmit, existingItems } = props;
  // const [check, setMdiCheck] = useState(true);
  const [editable, setEditable] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setEditable(edit);
  }, []);
  useEffect(() => {
    if (props.data) {
      setData({ ...props.data });
    }
    if (props.product) {
      setData((prev) => ({
        ...prev,
        // id: generate_id(), // generate id for new entry here
        item: props.product,
      }));
    }
  }, [props.data, props.product]);

  useEffect(() => {
    console.log("data.warehouse?.name", existingItems);
    if (data.warehouse?.name === undefined) {
      const existingItemWithWarehouse = (existingItems ?? []).find(
        (item) => !!item.warehouse && !!item.warehouse.id
      );

      if (existingItemWithWarehouse) {
        setData((prev) => ({
          ...prev,
          warehouse: existingItemWithWarehouse.warehouse,
        }));
      }
    }
  }, [existingItems, data.warehouse]);

  const handleInputChange = (index: number, value: string) => {
    setData((prev) => {
      const uniqueIds = [...(prev.uniqueIds ?? [])];

      if (uniqueIds[index]) {
        // Update existing row
        uniqueIds[index] = {
          ...uniqueIds[index],
          unique_id: value,
          item_name: data.item?.name,
        };
      } else {
        // Add new row if it doesn't exist
        uniqueIds[index] = {
          unique_id: value,
          item_name: data.item?.name,
        };
      }

      return {
        ...prev,
        uniqueIds,
      };
    });
  };

  const handleUniqueIdExists = async (value: string): Promise<boolean> => {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/items/unique-ids-exists?unique_id=${value}`;
    const res = await fetchGet(url);

    if (res.success) {
      return true;
    } else {
      showToast({
        type: ToastType.error,
        text: res.error,
      });
      return false;
    }
  };

  const onDone = async () => {
    const inputUniqueId = uniqueIdRef.current?.value.trim() ?? "";
    console.log("entry1:", data.id, inputUniqueId);

    if (!data.warehouse?.name || !inputUniqueId) {
      showToast({
        type: ToastType.warning,
        text: "Please select Unique ID and Warehouse",
      });
      return;
    }

    const isDuplicate = (existingItems ?? []).some((entry) => {
      if (entry.id === data.id) return false;
      console.log("entry:", entry.id, data.id);
      const entryUniqueIds = (entry.uniqueIds ?? []).map((u) =>
        (u.unique_id ?? "").trim().toLowerCase()
      );
      return entryUniqueIds.includes(inputUniqueId.toLowerCase());
    });

    if (isDuplicate) {
      showToast({
        type: ToastType.error,
        text: "This Unique ID is already added.",
      });
      return;
    }

    const isValid = await handleUniqueIdExists(inputUniqueId);
    if (!isValid) return;

    const submissionData: InwardItemModel = {
      ...data,
      uniqueIds: [
        {
          unique_id: inputUniqueId,
          item_name: data.item?.name,
        },
      ],
    };

    console.log("data:::", submissionData);
    onSubmit(submissionData);
  };

  // const onDone = async () => {
  //   const uniqueId = data.uniqueIds?.[0]?.unique_id ?? "";
  //   console.log("entry:", data.id, uniqueId);
  //   const isDuplicate = (existingItems ?? []).some((entry) => {
  //     // If editing, skip self-comparison

  //     if (entry.id === data.id) return false;

  //     const entryUniqueIds = (entry.uniqueIds ?? []).map((u) =>
  //       (u.unique_id ?? "").trim().toLowerCase()
  //     );

  //     return entryUniqueIds.includes(uniqueId);
  //   });
  //   if (isDuplicate) {
  //     showToast({
  //       type: ToastType.error,
  //       text: "This Unique ID is already added.",
  //     });
  //     return;
  //   }

  //   if (!data.warehouse?.name || !uniqueId) {
  //     showToast({
  //       type: ToastType.warning,
  //       text: "Please select Unique ID and Warehouse",
  //     });
  //     return;
  //   }

  //   const isValid = await handleUniqueIdExists(uniqueId);

  //   if (!isValid) return;
  //   console.log("data:::", data);
  //   onSubmit(data);
  // };

  const handleItemSelect = async (selectedItem: ItemModelV2) => {
    setData((prevData) => ({
      ...prevData,
      id: generate_id(),
      item: selectedItem,
    }));
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onDone();
      }}
      className="bg-white text-xs h-full"
    >
      <div className="border rounded-lg shadow-sm p-3 text-xs flex flex-col gap-2 bg-white h-full">
        {/* Item */}
        <div>
          <label className="text-gray-400">Item</label>
          <POItemSearchFieldV2
            disabled={!editable || props.disabled}
            value={data.item}
            onSelect={handleItemSelect}
          />
        </div>

        {/* Warehouse */}
        <div>
          <label className="text-gray-400">Warehouse</label>
          <WarehouseSearchField
            type={""}
            value={data.warehouse}
            placeholder=""
            onSelect={(d) => {
              setData((old) => {
                return {
                  ...old,
                  warehouse: d,
                };
              });
            }}
          />
        </div>

        <div className="grid grid-cols-2 gap-x-3 gap-y-2">
          <div>
            <span className="text-gray-400">Item Code</span>
            <div className="font-semibold break-words">
              {data?.item?.item_code ?? "--"}
            </div>
          </div>
          <div>
            <span className="text-gray-400">Unit Measure</span>
            <div className="font-semibold break-words">
              {data?.item?.unit?.symbol ?? "--"}
            </div>
          </div>
        </div>

        {/* Unique ID */}
        <div>
          <label className="text-gray-400">Unique ID</label>
          <input
            ref={uniqueIdRef}
            defaultValue={data.uniqueIds?.[0]?.unique_id ?? ""}
            placeholder="Enter Unique ID"
            type="text"
            className="w-full p-1 focus:outline-none border rounded"
            onChange={(e) => handleInputChange(0, e.target.value)}
          />
        </div>

        {/* Actions */}
        <div className="flex gap-2 items-center justify-end border-t pt-2 mt-auto">
          {props.data ? (
            !props.disabled && (
              <>
                {editable ? (
                  <>
                    <div
                      onClick={() => {
                        if (!window.confirm("Are you sure !")) return;
                        onDone();
                        setEditable(false);
                      }}
                      className="bg-green-100 p-1 rounded text-green-800 hover:scale-110 transform duration-200 cursor-pointer"
                    >
                      <Icon path={mdiCheck} className="h-4 w-4"></Icon>
                    </div>
                    <div
                      onClick={() => {
                        setData(props.data!);
                        setEditable(false);
                      }}
                      className="bg-red-100 p-1 rounded text-red-800 hover:scale-110 transform duration-200 cursor-pointer"
                    >
                      <Icon path={mdiClose} className="h-4 w-4"></Icon>
                    </div>
                  </>
                ) : (
                  <div
                    onClick={() => setEditable(true)}
                    className="bg-green-100 p-1 rounded text-green-800 hover:scale-110 transform duration-200 cursor-pointer"
                  >
                    <Icon path={mdiPencil} className="h-4 w-4"></Icon>
                  </div>
                )}
                <div
                  onClick={() => {
                    if (!window.confirm("Are you sure !")) return;
                    if (props.onDelete) props.onDelete(data);
                  }}
                  className="bg-red-200 p-1 rounded text-red-800 hover:scale-110 transform duration-200 cursor-pointer"
                >
                  <Icon path={mdiDelete} className="h-4 w-4"></Icon>
                </div>
              </>
            )
          ) : (
            <button className="flex gap-1 text-white text-xs bg-myPrimaryColor rounded-full px-3 py-1">
              <Icon path={mdiPlus} className="h-4 w-4"></Icon> Add
            </button>
          )}
        </div>
      </div>
    </form>
  );
};

export default InwardProductComponent;
